import { useParams } from "react-router-dom";

import { useURLDynamicParam } from "@/hooks/useURLDynamicParam";

/** テナント配下の画面は URL パスで対象テナントを受け取る */
export const usePathParamsTenantId = () => {
  const { tenantId } = useURLDynamicParam({
    paramName: "tenantId",
    type: "ulid",
  });

  return { tenantId };
};

/**
 * テナント配下かどうかが不定の場所から使う。
 *
 * usePathParamsTenantId はパラメータが無いと例外を投げるため、
 * サイドバーのように全画面で描画される要素からは使えない。
 */
export const useOptionalPathTenantId = (): string | undefined => {
  const { tenantId } = useParams<{ tenantId: string }>();

  return tenantId;
};
